import { render, staticRenderFns } from "./CacheStatistics.vue?vue&type=template&id=7d5312f2"
import script from "./CacheStatistics.vue?vue&type=script&lang=js"
export * from "./CacheStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports